import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import Visibility from '@mui/icons-material/Visibility';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import red from '@mui/material/colors/red';
import { Paper } from '@mui/material/';
import PhoneNumberInput from '../../components/PhoneNumberInput';

import {
  signupUserGuardian,
  signupUserWard,
} from '../../store/actions/register';
import { fetchInitVars } from '../../store/actions/common';
import { emailRegEx, passwordRegEx } from '../../constants/regex';
import * as ROUTES from '../../constants/routes';
import { ColoredButton } from '../../components/Buttons/colored';
import { _lt } from '../../localization/locale';
import formImage from '../../assets/images/Guardian_01.jpg';
import { useTheme } from '@mui/material/styles';

import 'react-phone-number-input/style.css';

const GuardianSignUpFormBase = (props) => {
  const theme = useTheme();

  const classes = {
    root: {
      background:
        'linear-gradient(#d3cff620,#ffffff,#ffffff,#d3cff610,#d3cff620)',
      backgroundSize: 'cover',
      height: 'calc(100vh - 2rem)',
      overflow: 'scroll',
      [theme.breakpoints.down('xs')]: {
        background: 'white',
      },
    },
    formWrapper: {
      width: '100%',
      maxWidth: '1200px',
      height: '500px',
      margin: '80px 32px 16px',
      boxShadow: '0px 10px 16px #d3cff650',
      border: '1px solid #1f1f3320',
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        height: 'max-content',
        flexDirection: 'column',
        margin: '80px 16px 16px',
      },
      [theme.breakpoints.down('xs')]: {
        margin: '80px 0 0',
        borderRadius: '0',
        boxShadow: 'none',
        border: 'none',
      },
    },
    formImage: {
      background: `url(${formImage}) no-repeat center`,
      backgroundSize: 'contain',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '300px',
        background: `url(${formImage}) no-repeat`,
        backgroundSize: 'cover',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    formContentsWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    formContents: {
      maxWidth: '400px',
      margin: '24px 16px 16px',
      [theme.breakpoints.down('sm')]: {
        margin: '24px',
      },
    },
    formTitleWrapper: {
      marginBottom: '24px',
    },
    formTitle: {
      color: '#4e4e7e',
      fontSize: '30px',
      fontWeight: '700',
      lineHeight: '1',
      [theme.breakpoints.down('xs')]: {
        fontSize: '24px',
      },
    },
    submitButton: {
      width: '300px',
      backgroundColor: '#ff0000',
      borderRadius: '99px',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
  };

  const pwdText =
    'Password must have one alphabet, one number or one special character and should be 6 characters or more';
  const emailText = `We'll send you a verification code, make sure you have access to the email, else you wont be able to proceed`;
  const mobileText = `We'll send you a verification code, make sure you have access to the phone, else you wont be able to proceed`;

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [error, setError] = useState({});
  const [mobile, setMobile] = useState('');
  const [useMobile, setUseMobile] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordText, setShowPasswordText] = useState(false);
  const [showEmailText, setShowEmailText] = useState(false);
  const [showMobileText, setShowMobileText] = useState(false);

  useEffect(() => {
    if (!props.initVars || props.initVars === null) {
      props.fetchInitVars();
    }
  }, []);
  useEffect(() => {
    if (mobile && isValidPhoneNumber(mobile)) {
      setShowMobileText(true);
    }
  }, [mobile]);

  const onSubmit = (event) => {
    event.preventDefault();
    if (!emailRegEx.test(email)) {
      toast.error(_lt('Invalid email'));
    } else if (!passwordRegEx.test(password)) {
      toast.error(_lt(pwdText));
    } else {
      if (props.choicesData === '3-31-311')
        props
          .signupUserWard(firstname, lastname, email, password, props.referer)
          .then(() => {
            props.history.push(ROUTES.SIGN_UP_OTP_GUARDIAN);
          })
          .catch((error) => {
            setError(error);
          });
      if (props.choicesData === '3-32-321' || props.choicesData === '1-11-')
        props
          .signupUserGuardian(
            firstname,
            lastname,
            email,
            password,
            props.referer,
          )
          .then(() => {
            props.history.push(ROUTES.SIGN_UP_OTP_GUARDIAN);
          })
          .catch((error) => {
            setError(error);
          });
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const isInvalid =
    password === '' || email === '' || firstname === '' || lastname === '';

  return (
    <Box display="flex" justifyContent="center" sx={classes.root}>
      <Paper elevation={0} sx={classes.formWrapper}>
        <Box sx={classes.formImage}></Box>
        <Box sx={classes.formContentsWrapper}>
          <Box sx={classes.formContents}>
            <form onSubmit={onSubmit}>
              <Grid direction="row" container spacing={1}>
                {/* -------------------------- RESPONSE TEXT -------------------------- */}
                <Grid item xs={12}>
                  <Box sx={classes.formTitleWrapper}>
                    <Typography variant="h6" gutterBottom>
                      {props.choicesData === '3-31-311' &&
                        _lt(
                          "We need the following to create your ward's account",
                        )}
                      {props.choicesData === '3-32-321' &&
                        _lt('We need the following to create your account')}
                      {props.choicesData === '1-11-' &&
                        _lt(
                          "We need the following to create your guardian's account",
                        )}
                    </Typography>
                    <Typography variant="subtitle" gutterBottom>
                      {props.choicesData === '3-31-311' &&
                        _lt(
                          "You will next be taken to the activation code verification screen for your ward's email/mobile",
                        )}
                      {props.choicesData === '3-32-321' &&
                        _lt(
                          'You will next be taken to the activation code verification screen for your email/mobile',
                        )}
                      {props.choicesData === '1-11-' &&
                        _lt(
                          "You will next be taken to the activation code verification screen for your guardian's email/mobile",
                        )}
                    </Typography>
                  </Box>
                </Grid>

                {/* -------------------------- FIRST NAME -------------------------- */}
                <Grid item xs={12} sm={6}>
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={props.signupError && !!props.signupError.firstname}
                  >
                    <InputLabel htmlFor="firstname-outlined">
                      {_lt('Firstname')}
                    </InputLabel>
                    <OutlinedInput
                      fullWidth
                      size="small"
                      name="firstname"
                      value={firstname}
                      onChange={(e) => setFirstname(e.target.value)}
                      type="text"
                      placeholder={_lt('Firstname')}
                      label={_lt('Firstname')}
                      error={props.signupError && props.signupError.firstname}
                      helperText={
                        props.signupError && props.signupError.firstname
                      }
                    />
                  </FormControl>
                </Grid>

                {/* -------------------------- LAST NAME -------------------------- */}
                <Grid item xs={12} sm={6}>
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={props.signupError && !!props.signupError.lastname}
                  >
                    <InputLabel htmlFor="lastname-outlined">
                      {_lt('Lastname')}
                    </InputLabel>
                    <OutlinedInput
                      fullWidth
                      size="small"
                      variant="outlined"
                      name="lastname"
                      value={lastname}
                      onChange={(e) => setLastname(e.target.value)}
                      type="text"
                      placeholder={_lt('Lastname')}
                      label={_lt('Lastname')}
                      error={props.signupError && props.signupError.lastname}
                      helperText={
                        props.signupError && props.signupError.lastname
                      }
                    />
                  </FormControl>
                </Grid>

                {/* -------------------------- EMAIL -------------------------- */}
                {!useMobile && (
                  <Grid item xs={12}>
                    <FormControl
                      size="small"
                      variant="outlined"
                      error={props.signupError && !!props.signupError.email}
                    >
                      <InputLabel htmlFor="email-outlined">
                        {_lt('Email')}
                      </InputLabel>
                      <OutlinedInput
                        fullWidth
                        size="small"
                        variant="outlined"
                        name="email"
                        value={email}
                        onChange={(e) => {
                          setShowEmailText(true);
                          setEmail(e.target.value);
                        }}
                        type="text"
                        placeholder={_lt('Email')}
                        label={_lt('Email')}
                        error={props.signupError && props.signupError.email}
                        helperText={
                          props.signupError && props.signupError.email
                        }
                      />
                    </FormControl>
                    {showEmailText && (
                      <Typography
                        variant="caption"
                        display="block"
                        color={'primary'}
                        gutterBottom
                      >
                        {_lt(emailText)}
                      </Typography>
                    )}
                  </Grid>
                )}
                {useMobile && (
                  <Grid item xs={12}>
                    <PhoneInput
                      international
                      countryCallingCodeEditable={false}
                      inputComponent={PhoneNumberInput}
                      value={mobile}
                      defaultCountry={
                        props.initVars ? props.initVars.country_code : null
                      }
                      onChange={setMobile}
                    />
                    {showMobileText && (
                      <Typography
                        variant="caption"
                        display="block"
                        color={'primary'}
                        gutterBottom
                      >
                        {_lt(mobileText)}
                      </Typography>
                    )}
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    sx={{ textAlign: 'right', cursor: 'pointer' }}
                    onClick={() => {
                      setUseMobile(!useMobile);
                    }}
                  >
                    {useMobile ? 'Use email instead' : 'Use mobile instead'}
                  </Typography>
                </Grid>

                {/* -------------------------- PASSWORD -------------------------- */}
                <Grid item xs={12} mb={2}>
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={props.signupError && !!props.signupError.email}
                  >
                    <InputLabel htmlFor="password-outlined">
                      {_lt('Password')}
                    </InputLabel>
                    <OutlinedInput
                      fullWidth
                      size="small"
                      variant="outlined"
                      type={showPassword ? 'text' : 'password'}
                      onChange={(e) => {
                        setShowPasswordText(true);
                        setPassword(e.target.value);
                      }}
                      name="password"
                      value={password}
                      placeholder={_lt('Password')}
                      label={_lt('Password')}
                      error={props.signupError && props.signupError.password}
                      helperText={
                        props.signupError && props.signupError.password
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {showPasswordText && (
                    <Typography
                      variant="caption"
                      display="block"
                      color={'primary'}
                    >
                      {_lt(
                        'Atleast one uppercase, one lowercase alphabets and one number or special character. And 6 or more in length',
                      )}
                    </Typography>
                  )}
                </Grid>
                {/* -------------------------- BUTTON -------------------------- */}
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                  <ColoredButton
                    sx={classes.submitButton}
                    disabled={isInvalid}
                    type="submit"
                    variant="contained"
                    bgcolor={red}
                    disableElevation
                  >
                    {_lt('Submit')}
                  </ColoredButton>
                </Grid>
              </Grid>
              <Typography variant="caption" display="block" gutterBottom>
                {error.message}
              </Typography>
            </form>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  signupError: state.register.errors,
  choicesData: state.register.choicesData,
  referer: state.common.siteReferrer,
  initVars: state.common.initVars,
});

const mapDispatchToProps = {
  signupUserGuardian,
  signupUserWard,
  fetchInitVars,
};

const GuardianSignUpForm = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GuardianSignUpFormBase),
);

export default GuardianSignUpForm;
